export const NODE_NAME = 'code_block';
export const CODE_BLOCK_REGEX = /^```$/;
export const PASTED_CODE_BLOCK_REGEX = /```(.*)([\s\S]*?)```/;
export const PERSISTENCE_KEY = 'lygo-editor-code-language';
export const DEFAULT_LANGUAGE = 'none';
